import type { AppState } from 'state/state.model';

import type {
  DiscoverPageState,
  LifeCycleCategory,
  LifeCycleProductsPagination,
  LifeCycleSection,
  Period,
  RubricType,
} from './page.model';

function select(state: AppState): DiscoverPageState {
  return state.discover?.page;
}

export function getDiscoverPageSelectedRegion(state: AppState) {
  return select(state)?.region;
}

export function getSelectedPostTradeTab(state: AppState) {
  const tab = select(state)?.selectedPostTradeTab;
  if (!tab) {
    return 'life-cycle';
  }
  return tab;
}

export function getSelectedRubricTab(state: AppState): RubricType {
  return select(state)?.selectedRubricTab;
}

export function getSelectedPeriod(state: AppState): Period {
  return select(state)?.selectedPeriod;
}

export function getLifecycleSection(state: AppState, category: LifeCycleCategory): LifeCycleSection {
  const page = select(state);
  return page?.lifeCycleSections?.find(s => category === s.category)!;
}

export function getSelectedLifecycleSectionCategory(state: AppState): LifeCycleCategory {
  const page = select(state);
  return page?.selectedSection;
}

export function getLifecycleSectionPagination(
  state: AppState,
  category: LifeCycleCategory,
): LifeCycleProductsPagination {
  return getLifecycleSection(state, category).pagination;
}
